const SCROLLBAR_WIDTH = 14;

export { SCROLLBAR_WIDTH };
//# sourceMappingURL=constants.js.map
